import ActionWords from "../../components/UKG/English/ActionWords";
import Articles from "../../components/UKG/English/Articles";
import Comprehension from "../../components/UKG/English/Comprehension";
import DescribingWords from "../../components/UKG/English/DescribingWords";
import NamingWords from "../../components/UKG/English/NamingWords";
import OneMany from "../../components/UKG/English/OneMany";
import OppositeWords from "../../components/UKG/English/OppositeWords";
import PhoneticWords from "../../components/UKG/English/PhoneticWords";
import PictureComposition from "../../components/UKG/English/PictureComposition";
import Pronoun from "../../components/UKG/English/Pronoun";
import QuestionWords from "../../components/UKG/English/QuestionWords";
import RhymingWords from "../../components/UKG/English/RhymingWords";
import SentenceFormation from "../../components/UKG/English/SentenceFormation";
import ThisThatTheseThose from "../../components/UKG/English/ThisThatTheseThose";
import VowelConsonant from "../../components/UKG/English/VowelConsonant";


// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/ukg/english-language/phonetic-words", title: "Phonetic Words", component: PhoneticWords},
    { url: "/ukg/english-language/articles", title: "Articles", component: Articles},
    { url: "/ukg/english-language/one-and-many", title: "One and Many", component: OneMany},
    { url: "/ukg/english-language/rhyming-words", title: "Rhyming Words", component: RhymingWords},
    { url: "/ukg/english-language/vowels-and-consonants", title: "Vowels and Consonants", component: VowelConsonant},
    //{ url: "/ukg/english-language/pronouns", title: "Pronouns", component: Pronoun},
    { url: "/ukg/english-language/this-that-these-those", title: "This–That & These–Those", component: ThisThatTheseThose},
    { url: "/ukg/english-language/picture-composition", title: "Picture Composition", component: PictureComposition},
    { url: "/ukg/english-language/formation-sentences", title: "Formation of Sentences", component: SentenceFormation},
    { url: "/ukg/english-language/opposites", title: "Opposites", component: OppositeWords},
    { url: "/ukg/english-language/comprehension", title: "Comprehension", component: Comprehension},
    { url: "/ukg/english-language/naming-words", title: "Naming Words", component: NamingWords},
    { url: "/ukg/english-language/action-words", title: "Action Words", component: ActionWords},
    { url: "/ukg/english-language/describing-words", title: "Describing Words", component: DescribingWords},
    { url: "/ukg/english-language/question-words", title: "Question Words", component: QuestionWords},
];


export default topics;